export default {
  default: [
    {
      path: "/dashboard",
      name: "dashboard",
      component: () => import("./views/DashboardView.vue")
    },
    {
      path: "/betalingen",
      name: "payments",
      component: () => import("./views/PaymentsView.vue")
    },
    {
      path: "/service",
      name: "service",
      component: () => import("./views/ServiceView.vue")
    }
  ]
};
